package ai.beakman.undercover.model

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

/**
 * Serializer de epoch millis (Long) com encoding específico por plataforma:
 *
 * - **android/ios**: `encodeLong`/`decodeLong` — comportamento idêntico ao histórico
 *   (Firestore grava `integerValue`), compatível com os builds mobile já distribuídos
 *   (TestFlight v8).
 * - **js**: `encodeDouble`/`decodeDouble` — no Kotlin/JS um `Long` é um objeto Kotlin
 *   ("custom Kn object"), que o Firebase Web SDK REJEITA em qualquer `setDoc`. `Double`
 *   vira `number` JS, e o SDK web grava number inteiro como `integerValue` → mesmo wire
 *   format das plataformas mobile.
 *
 * Epoch millis (~2^41) fica muito abaixo de 2^53, então a passagem por Double é exata.
 * A nulabilidade (ex.: `Room.timerStartedAt: Long?`) fica fora do serializer — o
 * kotlinx.serialization aplica o wrapper nullable automaticamente.
 */
object EpochMillisSerializer : KSerializer<Long> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("ai.beakman.undercover.model.EpochMillis", PrimitiveKind.LONG)

    override fun serialize(encoder: Encoder, value: Long) = encodeEpochMillis(encoder, value)
    override fun deserialize(decoder: Decoder): Long = decodeEpochMillis(decoder)
}

internal expect fun encodeEpochMillis(encoder: Encoder, value: Long)
internal expect fun decodeEpochMillis(decoder: Decoder): Long
